import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import usuarios from "../views/usuarios.vue";
import clientes from "../views/clientes.vue";
import reportes from "../views/reportes.vue";
import servicios from "../views/servicios.vue";
import turnos from "../views/turnos.vue";
import generarturno from "../views/generarturno.vue";
import modulos from "../views/modulos.vue";
import Signin from "../views/Signin.vue";
import pantalla from "../views/pantalla.vue";
import nofunciona from "../views/nofunciona.vue";

const routes = [
  {
    path: "/",
    name: "Signin",
    component: Signin,
  },
  {
    path: "/pantalla",
    name: "pantalla",
    component: pantalla,
  },

  {
    path: '/modulos',
    component: modulos,
    meta: { requiresAuth: true },
    children: [
      {
        path: "/inicio",
        name: "Dashboard",
        component: Dashboard,
        meta: { requiresAuth: true }
      },
      {
        path: "/usuarios",
        name: "usuarios",
        component: usuarios,
        meta: { requiresAuth: true }
      },
      {
        path: "/clientes",
        name: "clientes",
        component: clientes,
        meta: { requiresAuth: true }
      },
      {
        path: "/reportes",
        name: "reportes",
        component: reportes,
        meta: { requiresAuth: true }
      },
      {
        path: "/servicios",
        name: "servicios",
        component: servicios,
        meta: { requiresAuth: true }
      },
      {
        path: "/turnos",
        name: "turnos",
        component: turnos,
        meta: { requiresAuth: true }
      },
      {
        path: "/generarturno",
        name: "generarturno",
        component: generarturno,
        meta: { requiresAuth: true }
      },
    ]
},
{
  path: "/:catchAll(.*)",
  component: nofunciona
}
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    const token = sessionStorage.getItem('token');
    if (token) {
      next();
    } else {
      next('/');
    }
  } else {
    next();
  }
});

export default router;
